module.exports = __webpack_public_path__ + "img/home_adapt_vertical_down_normal.768c1bd7.svg";